import { request } from "../../Services/Api"

export const moveShopifyStore = ({ shopify_store_id, business_id }) =>
  request.api.post("/user/shopify/move/", { shopify_store_id, business_id })
